import { inject, Injectable } from '@angular/core';
import { ApModalServiceBase, convertModalResult } from 'webcommon/core-ui/modals-ng1520';
import { ApSignatureEditorModalComponent, signatureEditorResult2 } from './ap-signature-editor-modal.component';

// from PRM CaptureSignature.cs Panel, but really these are subjective
// this.panelInk.Size = new System.Drawing.Size(Uty.CaptureSignatureInkWidth, Uty.CaptureSignatureInkHeight);
// These are not the exact numbers from there, but the measures values when it's rendered on the screeen
const defaultPRMSignatureSize = {
  width: 374,
  height: 130,
} as const;

@Injectable({
  providedIn: 'root',
})
export class ApSignatureEditorModalService {
  private apModalService = inject(ApModalServiceBase);

  // 700 and 500 are just guesses for a reasonable signature size for ap-image-editor, but are not hard limits
  openModal64DataUrl(data?: Partial<ApSignatureEditorModalComponent['modalData']>) {
    return this.apModalService.showComponentModal$(ApSignatureEditorModalComponent, {
      panelClass: 'emds-modal2-auto',
      data: {
        height: 500,
        width: 700,
        ...data,
      },
    });
  }

  openModal64Data(data?: Partial<ApSignatureEditorModalComponent['modalData']>) {
    const dataWithDefaults = {
      ...defaultPRMSignatureSize,
      ...data,
    };

    return this.openModal64DataUrl(dataWithDefaults).pipe(
      convertModalResult((result): signatureEditorResult2 => {
        return {
          ...result,
          // look at notes in BrowserService.blobToBase64()
          base64Data: result.base64DataUrl.substring(result.base64DataUrl.indexOf(',') + 1),
        };
      }),
    );
  }
}
